//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


	import CFooter from "@/common/Footer";
	const baseList = [
    {
      url: '/user/act',
      img: '../../static/img/banner_00.jpg',
    },
	  {
		  url: '/',
		  img: '../../static/img/banner_01.jpg',
	  },
    {
		  url: '/freevhost',
		  img: '../../static/img/freevhost_suban.jpg',
	  },
    {
      url: '/freeserver',
      img: '../../static/img/freevps_suban.jpg',
    },
    {
      url: '/vhost',
      img: '../../static/img/vhost_suban.jpg',
    },
    {
      url: '/vps',
      img: '../../static/img/vps_suban.jpg',
    }
  ]
	const urlList = baseList.map((item, index) => ({
		url: item.url,
		img: item.img,
	}))

	const productList = [
    {
      title: '虚拟主机',
      subTil: ' 基于云计算的虚拟主机服务',
      content: '阿贝云虚拟主机，架设在高可用虚拟主机之上，具备高在线率、高安全性、高 稳定性等多项优势，提供独立IP，特别适用于对网站运行质量有较高要求的用 户，在线率高达99.99%。确保最稳定、安全、高效的系统运行。',
      money: '1',
      unit: '元/周起',
      bTxt: '立即选购',
      sTxt: '查看详情',
      seeUrl: '/vhost',
      buy: '/product/vhost',
      icon: 'icon_vhost'
    },
	  {
			title: '云服务器',
			subTil: '极速稳定高弹性的计算服务',
			content: '云服务器，架设在高可用虚拟主机之上，具备高在线率、高安全性、高稳定性 等多项优势，提供独立IP，特别适用于对网站运行质量有较高要求的用户，在 线率高达99.99%。确保最稳定、安全、高效的系统运行。',
			money: '3',
			unit: '元/3天起',
			bTxt: '立即选购',
			sTxt: '查看详情',
			seeUrl: '/vps',
			buy: '/product/server',
      icon: 'icon_vps'
		},
		{
			title: '域名注册',
			subTil: '提供五星级的域名注册服务',
			content: '超高的解析响应速度，强大的域名自助管理平台，无缝结合阿贝云虚拟主机，坚持让您花少量的费用，享更好的产品和服务',
			money: '9',
			unit: '元/年起',
			bTxt: '立即选购',
			sTxt: '查看详情',
			seeUrl: '/domain',
			buy: '/product/domain',
      icon: 'icon_domain'
		},
		{
			title: '快速备案',
			subTil: '国内免费空间第一品牌',
			content: '根据工信部规定提供中华人民共和国境内互联网信息服务，应当依法履行备案手续  阿贝云为您提供初审两小时返回结果、备案咨询等一站式备案服务。',
			money: '0',
			unit: '元永久免费',
			bTxt: '立即选购',
			sTxt: '查看详情',
			seeUrl: '/beian',
			buy: '/product/free',
      icon: 'icon_free'
		},
	]


	export default {
		data() {
			return {
				showA: '-1',
				demo06_list: urlList,
				demo06_index: 0,
				productList: productList,

			};
		},
		beforeCreate: function (){

			console.log('888');
		},
		computed: {

		},
		components: {
			CFooter
		},
		methods: {
			demo06_onIndexChange(index) {
				this.demo06_index = index
			},
			listDown(d) {
				if(this.showA == d) {
					this.showA = '-1'
				} else {
					this.showA = d
				}
			},
			dddd(){
				console.log('9090');
			}

		}
	};



// WEBPACK FOOTER //
// ./src/components/Home.vue